import { PolicyDriver } from "@modules/core";

export function formatPolicyDriverName(driver: PolicyDriver): string {
  return `${driver.partyLastName}, ${driver.partyFirstName} ${driver.partyMiddleInitial} ${driver.partyNameSuffix}`.replace(
    "  ",
    " "
  );
}
